import { useCallback, useEffect, useRef } from 'react';
import { useSetAtom } from 'jotai';
import type { WorkerFilterModel } from './types';
import { dashboardFilterAtom } from '../../filterAtom';

export const useWorkerFilter = (model: WorkerFilterModel | null) => {
  const setDashboardFilter = useSetAtom(dashboardFilterAtom);
  const previousModelReference = useRef<WorkerFilterModel | null>(null);

  const updateAtom = useCallback(
    (newModel: WorkerFilterModel | null) =>
      setDashboardFilter((previousFilter) => ({
        ...previousFilter,
        slaves:
          newModel?.workers && newModel.workers.length > 0
            ? newModel.workers
            : [],
      })),
    [setDashboardFilter]
  );

  useEffect(() => {
    const currentWorkers = model?.workers || [];
    const previousWorkers = previousModelReference.current?.workers || [];

    const hasChanged =
      currentWorkers.length !== previousWorkers.length ||
      currentWorkers.some((worker, index) => worker !== previousWorkers[index]);

    if (hasChanged) {
      updateAtom(model);
      previousModelReference.current = model;
    }
  }, [model, updateAtom]);
};

